import { html, nothing, LitElement, unsafeCSS } from "lit";
import { customElement, property } from "lit/decorators.js";
import { ref } from "lit/directives/ref.js";
import EkoChoiceElement from "@/utilities/choice-element";
import style from "./radio.css?inline";
import "@/components/admin-icon";

@customElement("eko-radio")
export class Radio extends EkoChoiceElement {
  static shadowRootOptions = { ...LitElement.shadowRootOptions, delegatesFocus: true };
  static styles = [...EkoChoiceElement.styles, unsafeCSS(style)];

  @property({ reflect: true, type: Boolean }) admin: boolean = false;
  @property() class: string = "";
  @property({ reflect: true }) size: "md" | "lg" = "md";
  @property({ reflect: true }) theme: "default" | "danger" = "default";

  private updateTabindex() {
    if (this.inputRef.value) {
      this.inputRef.value.tabIndex = this.tabIndex;
    }
  }

  connectedCallback() {
    super.connectedCallback();
    // Sync initial tabindex
    this.updateTabindex();
  }

  render() {
    return html` <div class="eko-radio" part="root">
      <label class="eko-radio__label" part="label">
        <span class="eko-radio__wrapper" part="wrapper">
          <input
            ${ref(this.inputRef)}
            type="radio"
            ?checked=${this.checked}
            @change=${this.handleChange}
            @focus=${this.handleFocus}
            @blur=${this.handleBlur}
            name=${this.name}
            value=${this.value}
            ?disabled=${this.disabled}
            class="eko-radio__input"
            part="input" />
          <span class="eko-radio__icon" part="icon"> </span>
        </span>
        <span class="eko-radio__label-text" part="text">
          <slot></slot>
          ${this.admin
            ? html`<span class="eko-radio__admin"><eko-admin-icon tooltip></eko-admin-icon></span>`
            : nothing}
        </span>
      </label>
      <slot name="description" class="eko-radio__description"></slot>
    </div>`;
  }

  updated(changedProperties: Map<string, any>) {
    if (changedProperties.has("checked")) {
      const input = this.inputRef.value as HTMLInputElement;
      if (input) {
        input.checked = this.checked;
      }
    }
  }

  set tabIndex(value: number) {
    super.tabIndex = value;
    this.updateTabindex();
  }

  get tabIndex(): number {
    return super.tabIndex;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "eko-radio": Radio;
  }
}
